import _ from 'lodash'

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  try {
    if (!sources.length) return target
    const source = sources.shift()

    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} })
          mergeDeep(target[key], source[key])
        } else {
          Object.assign(target, { [key]: source[key] })
        }
      }
    }

    return mergeDeep(target, ...sources)
  } catch (error) {
    console.error(error)
    return target
  }
}

/**
 * Deep cleanup of an object.
 * Receives an object and returns a copy cleared from empty arrays, objects, nulls and undefined
 * @note values [null], [1,null], 0, '' will not be affected
 * @param target
 * @returns a clean object
 */
export function deepClean(el) {
  function internalClean(el) {
    const _el = _.isArray(el) ? el : _.pickBy(el, (v) => !_.isNull(v) && !_.isUndefined(v)) // Clean all undefined and nulls in current hierarchy level
    return _.transform(_el, function (result, value, key) {
      // Transform is an alternative to reduce
      var isCollection = _.isObject(value)
      var cleaned = isCollection ? internalClean(value) : value // If an inner object/array was found recursively clean it
      if (isCollection && _.isEmpty(cleaned)) {
        return // If empty value don't add it to accumulator
      }
      _.isArray(result) ? result.push(cleaned) : (result[key] = cleaned) // Add result to accumulator
    })
  }

  return _.isObject(el) ? internalClean(el) : el // If object run recursive clean, else return the value
}
